import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const mainCategories = categories.slice(0, 6);
  const guideLinks = [
    { name: 'CSSBuy Spreadsheet 2026', path: '/cssbuy-spreadsheet-2026' },
    { name: 'O que é CSSBuy', path: '/cssbuy-o-que-e' },
    { name: 'Como Usar CSSBuy', path: '/como-usar-cssbuy' },
    { name: 'CSSBuy vs Pandabuy', path: '/cssbuy-vs-pandabuy-superbuy' },
    { name: 'Guia Iniciantes', path: '/guia-cssbuy-iniciantes' },
    { name: 'Erros Comuns', path: '/erros-cssbuy' },
    { name: 'Home', path: '/' },
  ];

  return (
    <footer className="bg-foreground-950">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="bg-foreground-900 rounded-3xl px-6 md:px-12 py-10 md:py-14 flex flex-col md:flex-row gap-10 md:gap-16">
          <div className="md:w-1/4">
            <Link to="/" className="font-heading text-xl font-bold text-white cursor-pointer">
              CSSBuy <span className="text-accent-400">Spreadsheet</span>
            </Link>
            <p className="text-white/50 text-sm mt-3 leading-relaxed">
              O seu guia completo para encontrar os melhores produtos da China usando CSSBuy Spreadsheet. Informações atualizadas, comparações e links diretos.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs font-semibold text-white/30 uppercase tracking-wider mb-4">CATEGORIAS</h4>
              <div className="flex flex-col gap-2">
                {mainCategories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-white/60 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-white/30 uppercase tracking-wider mb-4">GUIAS</h4>
              <div className="flex flex-col gap-2">
                {guideLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm text-white/60 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-white/30 uppercase tracking-wider mb-4">LEGAL</h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-white/40 cursor-default whitespace-nowrap">Privacy Policy</span>
                <span className="text-sm text-white/40 cursor-default whitespace-nowrap">Terms of Use</span>
                <span className="text-sm text-white/40 cursor-default whitespace-nowrap">Disclaimer</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-white/30">
            <span>&copy; 2026 CSSBuy Spreadsheet</span>
            <span className="hidden sm:inline">|</span>
            <span>Todos os direitos reservados</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white/50 hover:bg-accent-400/20 hover:text-accent-300 transition-colors cursor-pointer">
              <i className="ri-global-line text-sm"></i>
            </a>
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white/50 cursor-default">
              <i className="ri-twitter-x-line text-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}